import { render, staticRenderFns } from "./TruncateTool.vue?vue&type=template&id=0dfb1301"
import script from "./TruncateTool.vue?vue&type=script&lang=js"
export * from "./TruncateTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports